import React, { FC } from 'react';
import { IconButton } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from '.';
import { SizeMapKeys, SpriteIcon } from 'src/config/api/models/FontAwesome';

export type FontAwesomeSpriteButtonProps = {
  icon: SpriteIcon;
  color?: string;
  iconSize?: SizeMapKeys;
  disabled?: boolean;
  buttonStyle?: React.CSSProperties;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  id?: string;
};

const FontAwesomeSpriteButton: FC<FontAwesomeSpriteButtonProps> = ({
  onClick = () => {},
  disabled,
  buttonStyle = {},
  id,
  ...restProps
}) => {
  return (
    <IconButton style={buttonStyle} disabled={disabled} color="inherit" onClick={onClick} id={id}>
      <FontAwesomeSpriteIcon {...restProps} isDisabled={disabled} />
    </IconButton>
  );
};

export default FontAwesomeSpriteButton;
